import { MarkerItem } from '../types/home';
import { ShoppingItem } from '../types/shopping';

export const getNextFreeNumber = (
  markerCollections: MarkerItem[],
  shoppingItems: { [key: string]: { [key: string]: ShoppingItem } }
) => {
  let labels = markerCollections.map((x) => x.label);

  const shoppingKeys = Object.keys(shoppingItems);

  labels = labels
    .filter((label) => !shoppingKeys.includes(label))
    .concat(shoppingKeys);

  let num = labels.length + 1;
  const name = 'P';
  while (labels.some((label) => label === name + num)) {
    num++;
  }
  return num.toString();
};
